import VForm from "@/vuetify_custom/v-form";
import VTable from "@/vuetify_custom/v-table/v3";
import VModel from "@/vuetify_custom/v-modal_v1";
import { commonValidateRule } from "@/libs/rules_utils.js";
import { TEXT_FIELD, DIST_PICKER } from "@/vuetify_custom/v-form/type_name";

import {
  getThirdPartyMallAvailableStockNumApi,
  getSellDeliverOrderDetailApi,
  getSellOrderDetailApi,
  getSellDeliverOrderSaveApi,
} from "./services";
import NumberField from "@/vuetify_custom/v-form/components/Number_Field.js";
import { SellTypeMap } from "./constants";
const commonValidateRuleT = commonValidateRule("必填");

function createDeliverOrders(sellOrder, deliverOrder) {
  if (!deliverOrder.id) {
    return sellOrder?.sell_order_items?.map((item) => {
      return {
        contract_product_price_info_id: item.product_price_info.id,
        sell_order_item_id: item.id,
        item_id: item.item_id,
        sub_item_id: item.sub_item_id,
        stock_id: item.stock_id,
        stock_code: item.stock_code,
        stock_name: item.stock_name,
        sell_type: item.sell_type,
        price: item.price,
        tax_rate: item.tax_rate,
        quantity: 0,
        // 额外信息，仅做展示
        delivered_quantity: item.delivered_quantity,
        order_quantity: item.quantity,
          remaining_quantity: item.quantity - item.delivered_quantity,
      };
    });
  } else {
    return deliverOrder.sell_deliver_order_items.map((item) => {
      const sellOrderItem = sellOrder.sell_order_items.find(
        (item1) => item1.id === item.sell_order_item_id
      );
      return {
        ...item,
        delivered_quantity: sellOrderItem.delivered_quantity,
        order_quantity: sellOrderItem.quantity,
          remaining_quantity: sellOrderItem.quantity - item.delivered_quantity,
      };
    });
  }
}

function createParams(params, sellOrder) {
  return {
    id: params?.id || null,
    uid: params?.uid || null,
    contract_id: params?.contract_id || sellOrder?.contract_id || null,
    sell_order_id: params?.sell_order_id || sellOrder?.id || null,
    payee_company_name:
      params?.payee_company_name || sellOrder?.payee_company_name || null,
    name: params?.name || null,
    recv_user: params?.recv_user || null,
    recv_contact: params?.recv_contact || null,
    province: params?.province || null,
    city: params?.city || null,
    area: params?.area || null,
    recv_detail_address: params?.recv_detail_address || null,
    memo: params?.memo || null,
    sell_deliver_order_items: createDeliverOrders(sellOrder, params),

    // 额外信息
    // payee_company_name: sellOrder.payee_company_name,
    sell_order_uid: sellOrder.uid,
  };
}

export default {
  data() {
    return {
      dis: false,
      submitLoading: false,
      loading: false,
      params: createParams({}, {}),
      stockAmountHash: {},
      sellOrder: null,
    };
  },
  computed: {
    baseInfoFields() {
      const arr = [
        {
          label: "渠道",
          key: "payee_company_name",
          type: TEXT_FIELD,
          disabled: true,
        },
        {
          label: "订单编号",
          type: TEXT_FIELD,
          key: "sell_order_uid",
          cols: 12,
          disabled: true,
        },
        {
          label: "发货通知号",
          type: TEXT_FIELD,
          key: "uid",
          cols: 12,
          disabled: true,
        },
        {
          label: "收货人",
          type: "text_field",
          key: "recv_user",
          cols: 12,
          inline: true,
          row: true,
          rules: [commonValidateRuleT],
        },
        {
          label: "收货人手机号",
          key: "recv_contact",
          type: "text_field",
          cols: 12,
          inline: true,
          row: true,
          rules: [commonValidateRuleT],
        },
        {
          label: "省市",
          type: DIST_PICKER,
          key: "province",
          // province_key: "province",
          // city_key: "city",
          // area_key: "area",
          province_name_key: "province",
          city_name_key: "city",
          area_name_key: "area",
          cols: 12,
          required: true,
          rules: [commonValidateRuleT],
        },
        {
          label: "详细地址",
          key: "recv_detail_address",
          type: "text_field",
          cols: 12,
          inline: true,
          row: true,
          rules: [commonValidateRuleT],
        },
        {
          label: "订单备注",
          type: "text_field",
          key: "memo",
          cols: 12,
        },
        {
          key: "table",
          cols: 12,
        },
      ];
      return arr.filter((item) => !item.hide);
    },
    table_fields() {
      return [
        {
          text: "sku代码",
          align: "center",
          value: "stock_code",
          width: 150,
        },
        {
          text: "sku名称",
          align: "center",
          value: "stock_name",
          width: 150,
        },
        {
          text: "销售类型",
          align: "center",
          value: "sell_type",
          width: 150,
          render: (_, item) => {
            return <span>{SellTypeMap[item.sell_type] || "-"}</span>;
          },
        },
        {
          text: "订单数量",
          align: "center",
          value: "order_quantity",
          width: 150,
        },
        {
          text: "已发数量",
          align: "center",
          value: "delivered_quantity",
          width: 150,
        },
        {
          text: "剩余待发",
          align: "center",
          value: "remaining_quantity",
          width: 150,
          render: (_, item) => {
            return (
              <span>
                {math
                  .eval(`${item.order_quantity}-${item.delivered_quantity}`)
                  .toFixed(0) || 0}
              </span>
            );
          },
        },
        // {
        //   text: "可用库存",
        //   align: "center",
        //   value: "available_stock",
        //   width: 150,
        //   render: (_, item) => {
        //     return <span>{this.stockAmountHash[item.stock_code] || 0}</span>;
        //   },
        // },
        {
          text: "本次发货数量",
          align: "center",
          value: "quantity",
          width: 150,
          render: (_, item) => {
            return (
              <NumberField
                v-model={item}
                field={{
                  key: "quantity",
                  change: () => {},
                  rules: [
                    (val) => {
                      // if (
                      //   Number(val) >
                      //   Math.max(
                      //     Number(this.stockAmountHash[item.stock_code]),
                      //     0
                      //   )
                      // ) {
                      //   return "可用库存不足";
                      // }
                      // let count = 0;
                      // for (const one of this.params.sell_deliver_order_items) {
                      //   if (one.stock_code === item.stock_code) {
                      //     count += Number(one.quantity);
                      //   }
                      // }
                      // if (
                      //   count >
                      //   Math.max(
                      //     Number(this.stockAmountHash[item.stock_code], 0)
                      //   )
                      // ) {
                      //   return "可用库存不足";
                      // }
                      if (Number(val) < 0) {
                        return "数量不能小于0";
                      }
                      if (Number(val) > Number(item.remaining_quantity)) {
                        return "数量不能大于剩余待发货数量";
                      }
                      // 不可以输入小数
                      if (Number(val) % 1 !== 0) {
                        return "数量不能输入小数";
                      }
                      return true;
                    },
                  ],
                }}
              />
            );
          },
        },
      ];
    },
    sellOrderItems() {
      return this.sellOrder?.sell_order_items || [];
    },
  },
  watch: {
    sellOrderItems: {
      handler(newVal) {
        if (newVal.length) {
          const codes = newVal.map((item) => item.stock_code).join(",");
          // this.getStockAmount(codes);
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    add(sellOrderId) {
      this.dis = true;
      this.loading = true;
      getSellOrderDetailApi({ id: sellOrderId })
        .then((sellOrder) => {
          this.sellOrder = sellOrder;
          this.params = createParams({}, sellOrder);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit(sellOrderId, deliverOrderId) {
      this.dis = true;
      this.loading = true;
      Promise.all([
        getSellOrderDetailApi({ id: sellOrderId }),
        getSellDeliverOrderDetailApi({ id: deliverOrderId }),
      ])
        .then(([sellOrder, deliverOrder]) => {
          this.sellOrder = sellOrder;
          this.params = createParams(deliverOrder, sellOrder);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit() {
      if (
        !(
          this.$refs.base &&
          this.$refs.base.validate &&
          this.$refs.base.validate()
        )
      ) {
        return;
      }
      if (
        this.params.province === "省" ||
        this.params.city === "市" ||
        this.params.area === "区"
      ) {
        this.$Message.error("请选择省市区");
        return;
      }

      this.submitLoading = true;
      // const { sell_deliver_order_items } = this.params;
      // const newSellOrderItems = sell_deliver_order_items.map((item) => {
      //   return {
      //     ...item,
      //     amount: this.calcAmount(item),
      //   };
      // });
      const { payee_company_name, sell_order_uid, ...rest } = this.params;
      console.log(payee_company_name, sell_order_uid);
      const params = {
        ...rest,
      };
      if (!this.params.id) {
        delete params.id;
      }
      getSellDeliverOrderSaveApi(params)
        .then(() => {
          this.dis = false;
          this.$emit("success");
          this.$Message.success("保存成功！");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    close() {
      this.dis = false;
      this.$emit("close");
    },
    /**
     * 获取外部sku库存
     */
    // getStockAmount(codes) {
    //   getThirdPartyMallAvailableStockNumApi({ stock_codes: codes }).then(
    //     (res) => {
    //       console.log("res", res);
    //       if (Array.isArray(res)) {
    //         res.forEach((item) => {
    //           this.stockAmountHash[item.sku_code] = item.available_stock_num;
    //         });
    //         this.$forceUpdate();
    //       }
    //     }
    //   );
    // },
  },
  render() {
    return (
      <VModel
        fullscreen
        v-model={this.dis}
        persistent
        dynamic-height
        height-rate={0.7}
        title={this.params.id ? "编辑" : "新建"}
        loading={this.submitLoading}
        on={{
          ok: this.submit,
          cancel: this.close,
        }}
      >
        <VForm
          ref="base"
          v-model={this.params}
          fields={this.baseInfoFields}
          scopedSlots={{
            table: () => {
              return (
                <div>
                  <VTable
                    headers={[...this.table_fields]}
                    desserts={this.params.sell_deliver_order_items}
                  />
                </div>
              );
            },
          }}
        />
      </VModel>
    );
  },
};
